import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { InboxTaskType } from '@treams/treams-network';
import { Tabs } from '@treams/treams-ui';

export default function ViewerFeedbackTabs() {
	const { t } = useTranslation();

	const hasFeedback = useFeature(graphql.FeatureName.Feedback);
	const hasCompliments = useFeature(graphql.FeatureName.Compliments);
	const hasSharedFeedback = useFeature(graphql.FeatureName.FeedbackShare);

	const { data } = graphql.useInboxTasksQuery();

	const counter = (data?.viewer.inboxTasks.slice() ?? []).filter(
		(task) => task.type === InboxTaskType.FeedbackRequestPending,
	).length;

	return (
		<Tabs.Container>
			{hasFeedback && (
				<Tabs.Item title={t('feedback.tab.incoming.title')} selected path="/feedback" />
			)}
			{hasFeedback && (
				<Tabs.Item
					title={t('feedback.tab.outgoing.title')}
					path="/feedback/given"
					{...(counter > 0 && { counter })}
				/>
			)}
			{hasSharedFeedback && (
				<Tabs.Item title={t('feedback.tab.shared.title')} path="/feedback/shared" />
			)}
			{hasCompliments && (
				<Tabs.Item title={t('feedback.tab.compliments.title')} path="/feedback/compliments" />
			)}
		</Tabs.Container>
	);
}
